module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav"
  }, [_c('el-menu', {
    attrs: {
      "unique-opened": true,
      "default-active": _vm.active
    },
    on: {
      "select": _vm.goToPage
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', [_vm._v("租户管理")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-1"
    }
  }, [_vm._v("租户管理(企业)")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-2"
    }
  }, [_vm._v("租户管理（产品开发）")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-3"
    }
  }, [_vm._v("租户账号管理")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', [_vm._v("系统管理")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2-1"
    }
  }, [_vm._v("开发人员管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2-2"
    }
  }, [_vm._v("角色管理")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "3"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', [_vm._v("资源管理")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3-1"
    }
  }, [_vm._v("资源配置")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3-2"
    }
  }, [_vm._v("套餐配置")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "4"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', [_vm._v("版本管理")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "4-1"
    }
  }, [_vm._v("行业版本")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "4-2"
    }
  }, [_vm._v("租户版本")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "4-3"
    }
  }, [_vm._v("租户账号版本")])], 2)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-97c28c9e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97c28c9e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/menu/Index.vue
// module id = 171
// module chunks = 0